<template>
  <div>
    <div class="content-form-calification">
      <div class="header">
        Registro del empleado que participo en la calificación
      </div>
      <div>
        <div class="mb-4 mt-4 row">
          <div class="col-md-6">
            <SelectSearch
              placeholder="Seleccionar Empleado"
              name="name"
              label="Empleado"
              :options="employess"
              :loading="loading"
              :disabled="false"
              :value="employee"
              @input="(value) => selectedEmployee(value)"
              @search="(value) => searchEmployee(value)"
            />
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-12">
            <InformationEmployee :employee="employee" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <UploadFilePhoto @uploadFile="(value) => (formData.user_photo = value)" :isBusy="isBusy" :dowlandLink="dowlandLink" />
          </div>
        </div>
        <div class="d-flex justify-content-center mb-4 mt-4" v-if="!formData.user_photo?.url">
          <button
            class="button_primary"
            type="button"
            @click.prevent="saveData()"
            :disabled="isBusy || isDisabled"
          >
            <b-spinner v-if="isBusy" />
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformationEmployee from "../InformationEmployee.vue";
import SelectSearch from "../SelectSearch.vue";
import UploadFilePhoto from "../UploadFilePhoto.vue";
import {
  getEmployees,
  savePhoto
} from "@/services/health-tracker/matrizIper/service";
export default {
  components: {
    SelectSearch,
    UploadFilePhoto,
    InformationEmployee,
  },
  props: {
    idMatrizIper: {
      type: Number,
      default: null,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      employess: [],
      loading: false,
      formData: {
        user_photo: null,
        user_id: null,
      },
      isBusy: false,
      search: "",
      abortController: null,
      employee: null,
      dowlandLink: null,
    };
  },
  computed: {
    isDisabled() {
      const me = this;
      const isDisabled =
        me.formData.user_id === null ||
        me.formData.user_photo === null
          ? true
          : false;
      return isDisabled;
    },
  },
  watch: {
    record() {
      const me = this;
      if (me.record) me.loadData();
    }
  },
  methods: {
    selectedEmployee(value) {
      const me = this;
      me.employee = value;
      me.formData.user_photo = null;
      me.dowlandLink = null;
      me.formData.user_id = value.id;
    },
    async loadEmployess() {
      const me = this;
      me.loading = true;
      me.employess = [];
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { result } = await getEmployees(
          {
            search: me.search,
          },
          signal
        );
        me.employess = result;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    searchEmployee(value) {
      const me = this;
      me.search = value;
      me.loadEmployess();
    },
    async saveData() {
      const me = this;
      me.isBusy = true;
      const formData = new FormData();

      if (!me.formData.user_photo?.url)formData.append("user_photo", me.formData.user_photo);
      formData.append("user_id", me.formData.user_id);
      try {
        await savePhoto(formData, me.idMatrizIper);
        me.$emit("saveDataSuccess", "Registro empleado guardado exitosamente");
      } catch (error) {
        console.log(error)
        me.$emit("saveDataError", "Error al guardar Formulario");
      } finally {
        me.isBusy = false;
      }
    },
    async loadData() {
      const me = this;
      if (me.record?.user_id) {
        const item = me.employess.find((x) => x.id === me.record?.user_id);
        if (item) {
          me.employee = item;
          me.formData.user_id = me.record?.user_id || null;
        }
      }
      me.formData.user_photo = me.record?.user_photo || null;
      me.dowlandLink = me.record?.user_photo?.url || null;
    },
  },
  async mounted() {
    const me = this;
    await me.loadEmployess();
    if (me.record) me.loadData();
  }
};
</script>

<style lang="scss" scoped>
.content-form-calification {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
  text-align: left !important;
}
.content-form-calification .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
</style>
